import { render } from "./AggregateSalesDashboard.vue?vue&type=template&id=5e0bc594&scoped=true"
import script from "./AggregateSalesDashboard.vue?vue&type=script&lang=js"
export * from "./AggregateSalesDashboard.vue?vue&type=script&lang=js"

import "./AggregateSalesDashboard.vue?vue&type=style&index=0&id=5e0bc594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e0bc594"]])

export default __exports__